module.exports = __webpack_public_path__ + "static/img/13.260966c1.png";